import { RG_TYPE } from '../../types/rg-type.js';

const DefaultZone = {
    type: RG_TYPE.Zone,
    data: {
        polygons: [[[-10, 0, -10], [10, 0, -10], [5, 0, 5], [-10, 0, -10]]],
        realPoly: [[-10, 0, -10], [10, 0, -10], [5, 0, 5], [-10, 0, -10]],
        holes: []
    },
    children: []
};

export { DefaultZone };
//# sourceMappingURL=default-zone.js.map
